var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from 'react-bootstrap/Modal';
import "../styles/ModalNewRequest.css";
import "../styles/Arts.css";
import CloseIcon from '@mui/icons-material/Close';
import UploadingArtFiles from "../components/UploadingArtFiles";
function ModalNewRequest(props) {
    return (_jsxs(Modal, __assign({}, props, { "aria-labelledby": "contained-modal-title-vcenter", centered: true, className: "modal-new-request modal-arts" }, { children: [_jsxs(Modal.Header, { children: [_jsx("h3", { children: "Nova Solicita\u00E7\u00E3o" }), _jsx(CloseIcon, { onClick: props.closeModal })] }), _jsxs(Modal.Body, { children: [_jsx("div", __assign({ className: "card-alert-new-request" }, { children: _jsx("p", { children: "Caso esta solicita\u00E7\u00E3o esteja relacionado \u00E0 outra j\u00E1 feita anteriormente, por favor, clique em cancelar e responda na solicita\u00E7\u00E3o correspondente." }) })), _jsx(UploadingArtFiles, { pageName: "upload_arts", closeModal: props.closeModal })] })] })));
}
export default ModalNewRequest;
